import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, inputCls, btnCls } from "@/pages/AuthShell";
import { formatApiError } from "@/lib/api";
import { SocialButtons, Divider } from "@/components/SocialButtons";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      navigate(user.onboarded ? "/dashboard" : "/onboarding");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Bentornato"
      subtitle="Accedi per gestire le tue guide ospiti"
      footer={
        <div className="space-y-3">
          <p>Non hai un account? <Link to="/signup" className="font-semibold text-blue-600">Registrati</Link></p>
          <p data-testid="login-legal-note" className="text-xs text-slate-400 leading-relaxed">
            Accedendo accetti i{" "}
            <Link to="/termini" className="underline hover:text-slate-600">Termini di Servizio</Link>{" "}
            e la{" "}
            <Link to="/privacy" className="underline hover:text-slate-600">Privacy Policy</Link>.
          </p>
        </div>
      }
    >
      <SocialButtons />
      <Divider />
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <input data-testid="login-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} required />
        <input data-testid="login-password" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} required />
        <div className="text-right">
          <Link to="/forgot-password" className="text-sm text-slate-500 hover:text-slate-800">Password dimenticata?</Link>
        </div>
        {error && <p data-testid="login-error" className="text-sm text-red-500">{error}</p>}
        <button data-testid="login-submit" type="submit" disabled={loading} className={btnCls}>
          {loading ? <Loader2 className="w-4 h-4 animate-spin mx-auto" /> : "Accedi"}
        </button>
      </form>
    </AuthShell>
  );
}
